exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "nz-radio-group-stretcher{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}nz-radio-group-stretcher nz-radio-group{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}nz-radio-group-stretcher nz-radio-group label.ant-radio-button-wrapper{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;text-align:center}", ""]);

// exports
